import { TRootState } from '../../../common/reducers';

export const selectRequestSuccessManagerSent = (state: TRootState): boolean => {
  return state.requestSuccessManager.requestSent;
};
